import React, { PureComponent } from 'react';


export default function wrap(Component) {
  return class DecimalField extends PureComponent {
    constructor(props) {
      super(props);
      this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event, ...rest) {
      const { value: val, name } = event.target;
      // allow numbers and only one decimal
      const value = val.replace(/[^0-9.]+/g, '').replace(/(\..*)\./g, '$1');
      this.props.onChange({ value, name }, ...rest);
    }

    render() {
      const { value, onInputRef, ...rest } = this.props;
      return <Component {...rest} ref={onInputRef} value={value} onChange={this.handleChange} />;
    }
  };
}
